/**
 * pdp-saving-countdown.js
 *
 * PDP saving badge 直降倒计时驱动。
 *
 * 倒计时内嵌在 saving badge（[data-pdp-saving-badge]）内：
 *   - [data-pdp-saving-text]：文案（"SAVE $xx.xx"），由 pdp.js 的 PdpPrice 维护
 *   - [data-pdp-saving-countdown]：倒计时（HH:MM:SS），由本脚本驱动
 *
 * variant 切换时，pdp.js 派发 variant:changed 事件（含 isInit 首屏标志），
 * 本脚本监听该事件，自行判断直降（variant.compare_at_price > variant.price）
 * 并从 [data-pdp-saving-countdown-map] 查找 per-variant endMs。
 *
 * HTML 约定：
 *   <span class="lute-price-saving-badge" data-pdp-saving-badge>
 *     <span class="lute-price-saving-badge__text" data-pdp-saving-text>...</span>
 *     <span class="lute-price-saving-badge__countdown" data-pdp-saving-countdown hidden>
 *       <svg class="lute-price-saving-badge__clock">...</svg>
 *       <span class="lute-price-saving-badge__timer">
 *         <span class="lute-price-saving-badge__digit" data-sc-hh>00</span>
 *         <span class="lute-price-saving-badge__sep">:</span>
 *         <span class="lute-price-saving-badge__digit" data-sc-mm>00</span>
 *         <span class="lute-price-saving-badge__sep">:</span>
 *         <span class="lute-price-saving-badge__digit" data-sc-ss>00</span>
 *       </span>
 *     </span>
 *   </span>
 *
 * 显隐逻辑：
 *   - 非直降 或 endMs <= 0 → 隐藏
 *   - remainMs <= 0 → 隐藏（倒计时结束）
 *   - remainMs > 172799000（47:59:59，最大 48 小时）→ 隐藏，60s 轮询进入窗口后显示
 *   - 0 < remainMs <= 172799000 → 显示，每秒 tick 更新 data-sc-hh/mm/ss
 */

(function () {
  'use strict';

  var INIT_KEY = '__pdpSavingCountdownInit__';
  if (window[INIT_KEY]) return;
  window[INIT_KEY] = true;

  var MAX_REMAIN_MS = 172799000;      // 47:59:59（最大 48 小时）
  var POLL_INTERVAL_MS = 60 * 1000;

  /* ── 工具函数 ── */

  function pad2(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function msToHMS(ms) {
    var totalSec = Math.max(0, Math.floor(ms / 1000));
    var hh = Math.floor(totalSec / 3600);
    var mm = Math.floor((totalSec % 3600) / 60);
    var ss = totalSec % 60;
    return { hh: pad2(hh), mm: pad2(mm), ss: pad2(ss) };
  }

  /* ── DOM 引用 ── */

  var badgeEl = document.querySelector('[data-pdp-saving-badge]');
  var countdownEl = badgeEl ? badgeEl.querySelector('[data-pdp-saving-countdown]') : null;
  var hhEl = countdownEl ? countdownEl.querySelector('[data-sc-hh]') : null;
  var mmEl = countdownEl ? countdownEl.querySelector('[data-sc-mm]') : null;
  var ssEl = countdownEl ? countdownEl.querySelector('[data-sc-ss]') : null;

  /* ── 解析 per-variant endMs map ── */

  var variantMap = {};

  function parseMap() {
    var mapEl = document.querySelector('[data-pdp-saving-countdown-map]');
    if (!mapEl) return;
    try {
      var data = JSON.parse(mapEl.textContent);
      variantMap = data && data.variants ? data.variants : {};
    } catch (e) {
      variantMap = {};
    }
  }

  function getEndMs(variantId) {
    var ms = variantMap[String(variantId)];
    return typeof ms === 'number' && ms > 0 ? ms : 0;
  }

  /* ── 状态 ── */

  var currentEndMs = 0;
  var isDirectDiscount = false;
  var tickTimer = null;
  var pollTimer = null;

  /* ── 显隐与 tick ── */

  function updateDigits(remainMs) {
    var hms = msToHMS(remainMs);
    if (hhEl) hhEl.textContent = hms.hh;
    if (mmEl) mmEl.textContent = hms.mm;
    if (ssEl) ssEl.textContent = hms.ss;
  }

  function show() {
    if (countdownEl) countdownEl.hidden = false;
  }

  function hide() {
    if (countdownEl) countdownEl.hidden = true;
  }

  function stopTimers() {
    if (tickTimer) { clearInterval(tickTimer); tickTimer = null; }
    if (pollTimer) { clearTimeout(pollTimer); pollTimer = null; }
  }

  /** 同步抑制状态：直降倒计时活跃时通知折扣码倒计时隐藏 */
  function _notifySuppress(active) {
    window.__pdpSavingCountdownActive = active;
    document.dispatchEvent(new CustomEvent('pdp:saving-countdown-status', {
      detail: { active: active }
    }));
  }

  function tick() {
    var remainMs = currentEndMs - Date.now();
    if (remainMs <= 0 || !isDirectDiscount) {
      hide();
      stopTimers();
      _notifySuppress(false);
      return;
    }

    if (remainMs > MAX_REMAIN_MS) {
      // 窗口外：隐藏，60s 后重新检查。但直降倒计时仍活跃，需抑制折扣码倒计时
      hide();
      stopTimers();
      // _notifySuppress 由 evaluate 调用，这里保持活跃状态不变
      pollTimer = setTimeout(evaluate, POLL_INTERVAL_MS);
      return;
    }

    // 窗口内：显示并每秒 tick
    show();
    stopTimers();
    updateDigits(remainMs);
    tickTimer = setInterval(function () {
      var r = currentEndMs - Date.now();
      if (r <= 0) {
        hide();
        stopTimers();
        _notifySuppress(false);
        return;
      }
      if (r > MAX_REMAIN_MS) {
        hide();
        stopTimers();
        pollTimer = setTimeout(evaluate, POLL_INTERVAL_MS);
        return;
      }
      updateDigits(r);
    }, 1000);
  }

  function evaluate() {
    if (!isDirectDiscount || currentEndMs <= 0) {
      hide();
      stopTimers();
      _notifySuppress(false);
      return;
    }
    // 直降倒计时活跃（窗口内或 wait 态），抑制折扣码倒计时
    _notifySuppress(currentEndMs > Date.now());
    tick();
  }

  /* ── variant 切换 ── */

  function onVariantChanged(evt) {
    var variant = evt.currentVariant || (evt.detail && evt.detail.variant) || evt.detail;
    if (!variant) return;

    currentEndMs = getEndMs(variant.id);
    isDirectDiscount = variant.compare_at_price != null && variant.compare_at_price > variant.price;
    evaluate();
  }

  document.addEventListener('variant:changed', onVariantChanged);

  /* ── boot ── */

  function boot() {
    parseMap();

    // 主动从 DOM 读取当前 variant 并触发倒计时初始化
    // （pdp.js 在 <head> defer 优先执行，variant:changed 可能已在此脚本注册监听前派发，不可仅依赖事件）
    var initVariantId = null;
    var initVariant = null;

    // 1) 解析 [data-pdp-variants] JSON（Shopify product.variants 全量数据）
    var variantsEl = document.querySelector('[data-pdp-variants]');
    var variantsData = null;
    if (variantsEl) {
      try { variantsData = JSON.parse(variantsEl.textContent); } catch (e) {}
    }

    // 2) 判断当前 variant：URL param → 默认第一个
    var urlParamId = new URLSearchParams(window.location.search).get('variant');
    if (urlParamId) initVariantId = urlParamId;

    // 3) 在 variantsData 中查找匹配的 variant 对象
    if (variantsData && variantsData.length > 0) {
      if (!initVariantId) initVariantId = String(variantsData[0].id);
      for (var i = 0; i < variantsData.length; i++) {
        if (String(variantsData[i].id) === initVariantId) {
          initVariant = variantsData[i];
          break;
        }
      }
    }

    // 4) 如果有 variant，主动初始化倒计时（模拟 variant:changed）
    if (initVariant) {
      onVariantChanged({ currentVariant: initVariant });
    }

    // 兜底：如果倒计时 DOM 缺失，不继续
    if (!badgeEl || !countdownEl) return;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();